module.exports = __webpack_public_path__ + "img/haibao4@2x.319237af.png";